import { cn } from '~/util'

const OPTION_BASE = 'py-0.5 text-left text-sm text-neutral-midfi-grey data-[focus]:bg-blue-100/30'

export function optionClassName(isSelected: boolean, indent = false): string {
  return cn(
    OPTION_BASE,
    indent ? 'pl-3 pr-2' : 'px-2',
    isSelected ? 'cursor-default opacity-50' : 'cursor-pointer'
  )
}
